import { Star } from "lucide-react";

const testimonials = [
  { name: "Laurent M.", car: "Porsche 911", text: "Résultat bluffant. La peinture est absolument identique à l'origine. Un travail d'une précision remarquable.", rating: 5 },
  { name: "Sophie R.", car: "BMW X5", text: "Suite à un accident, ils ont tout géré : l'assurance, la réparation, la restitution. Je n'ai eu aucun stress.", rating: 5 },
  { name: "Marc D.", car: "Mercedes Classe E", text: "Le débosselage sans peinture a sauvé ma portière. Invisible, rapide, et bien moins cher qu'une repeinture complète.", rating: 5 },
  { name: "Jean-François L.", car: "Audi A4", text: "Suite à des dégâts de grêle, ProImpact a utilisé la technique de débosselage sans peinture. Résultat bluffant : on ne voit absolument rien, et en 2 heures c'était réglé. Rapport qualité/prix imbattable.", rating: 5 },
  { name: "Nathalie B.", car: "Volkswagen Golf", text: "Atelier très professionnel. Ils ont géré toutes les démarches avec mon assurance AXA, je n'ai eu qu'à déposer ma voiture et la récupérer une semaine plus tard en parfait état. La peinture est identique à l'origine.", rating: 5 },
  { name: "Thomas K.", car: "BMW Série 3", text: "J'avais rayé mes 4 jantes contre des trottoirs. ProImpact les a rénovées impeccablement pour un prix très raisonnable. On dirait qu'elles sortent de l'usine. Je recommande vivement.", rating: 5 },
  { name: "Alexandre D.", car: "Tesla Model 3", text: "Excellent service de detailing premium. Ma Tesla Model 3 de 3 ans a retrouvé une seconde jeunesse. Le polissage et le coating céramique ont fait des miracles. Travail minutieux et passionné.", rating: 5 },
  { name: "Isabelle M.", car: "Renault Clio", text: "Après un accident, ma portière arrière était très endommagée. ProImpact a fait un travail remarquable : tôlerie impeccable et peinture absolument invisible. Délai respecté. Bravo à toute l'équipe.", rating: 5 },
  { name: "Stéphane R.", car: "Peugeot 3008", text: "Sérieux, réactif, et très compétent. J'ai fait réparer mon pare-chocs avant suite à un accrochage. Le résultat est parfait et le prix était correct. Je ferai à nouveau appel à eux sans hésiter.", rating: 5 },
  { name: "Caroline P.", car: "Ford Fiesta", text: "ProImpact a réparé une grosse bosse sur mon capot avec la technique sans peinture. Je ne pensais pas que c'était possible. Et bien si, c'est invisible maintenant ! Rapide et efficace.", rating: 5 },
];

// Avis les plus précis (dégât, véhicule, délai) mis en avant.
const SHOWN = ["Sophie R.", "Marc D.", "Jean-François L.", "Nathalie B.", "Thomas K.", "Isabelle M."];

const TestimonialsSection = () => (
  <section id="temoignages" className="py-24 relative">
    <div className="container mx-auto px-4">
      <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Ce que disent nos clients</h2>
        <div className="flex items-center gap-3">
          <img src="/logos/google.png" alt="Google" className="h-6 w-6 object-contain" width={24} height={24} loading="lazy" />
          <span className="font-semibold">5,0</span>
          <div className="flex text-primary">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-current" />
            ))}
          </div>
          <span className="text-sm text-muted-foreground">sur Google</span>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {testimonials
          .filter((t) => SHOWN.includes(t.name))
          .map((t) => (
            <figure key={t.name} className="glass-card rounded-lg p-6 flex flex-col">
              <blockquote className="text-[0.9375rem] leading-relaxed flex-1">« {t.text} »</blockquote>
              <figcaption className="mt-5 text-sm">
                <span className="font-semibold">{t.name}</span>
                <span className="text-muted-foreground">, {t.car}</span>
              </figcaption>
            </figure>
          ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
